import apiClient from "@/services/ApiClient"

export default {
  name() {
    return "sessions"
  },
  getPdf(id) {
    return apiClient.get(`/sessions/${id}/pdf`)
  },
  clone(id) {
    return apiClient.post(`/sessions/${id}/clone`)
  },
}
